import { request, Response } from '../utils';

export const resendEmailConfirmation = (body: {
  username: string;
}): Response<null> => request('resend-email-confirmation', body);
